// Não necessita dos CDN's pois estamos utilizando diretamente uma biblioteca própria do Firebase
import firebase from 'firebase';

// Utilizando os arquivos .env para a segurança dos dados da aplicação
// É necessário sempre no inicio das variáveis o nome "REACT_APP_"
var firebaseConfig = {
    apiKey: `${process.env.REACT_APP_APIKEY}`,
    authDomain: `${process.env.REACT_APP_AUTHDOMAIN}`,
    projectId: `${process.env.REACT_APP_PROJECTID}`,
    storageBucket: `${process.env.REACT_APP_STORAGEBUCKET}`,
    messagingSenderId: `${process.env.REACT_APP_MESSAGINGSENDERID}`,
    appId: `${process.env.REACT_APP_APPID}`,
    measurementId: `${process.env.REACT_APP_MEASUREMENTID}`
};

// Inicialização do Firebase
const app = firebase.initializeApp(firebaseConfig);
firebase.analytics();

// Para utilizar o firestore nas páginas (Cloud Firestore - Banco de dados não relacional)
export const db = app.firestore();

// Sistema de armazenamento de arquivos do firebase
export const storage = firebase.storage;

// Para ter acesso à propriedade ao método "timestamp()" do servidor 
export const firebaseApp = firebase;

export default firebaseConfig;